module.exports = __webpack_public_path__ + "media/images/front/logo_casebook-494e7bdbb1556072ac344c2b2937916c.png";